import {
  DEFAULT_UNVERIFIED_WARRANTY_SOURCE,
  type WarrantyPeriodSource,
} from "./warrantyPeriodAuthority";

export type WarrantyEnrichmentProvenance = {
  label: string;
  needsReview: boolean;
};

export function describeWarrantyPeriodSource(
  source: WarrantyPeriodSource | string | null | undefined,
): WarrantyEnrichmentProvenance {
  switch (source) {
    case "catalogue_explicit":
      return { label: "Verified from catalogue", needsReview: false };
    case "proposal_item_explicit":
      return { label: "Confirmed in proposal", needsReview: false };
    case "configured_product_explicit":
      return { label: "Confirmed by product configuration", needsReview: false };
    case "manufacturer_research":
      return { label: "Verified from manufacturer source", needsReview: false };
    case "admin_override":
      return { label: "Confirmed by Admin", needsReview: false };
    case "staff_confirmed":
    case "manual_entry_default":
      return { label: "Confirmed by staff", needsReview: false };
    case DEFAULT_UNVERIFIED_WARRANTY_SOURCE:
    case "manufacturer_unverified":
      return { label: "Manufacturer warranty not yet verified", needsReview: true };
    default:
      return { label: "Source not recorded", needsReview: true };
  }
}

export function describeWarrantyImageSource(
  source: string | null | undefined,
): WarrantyEnrichmentProvenance {
  switch (String(source ?? "").trim().toLowerCase()) {
    case "proposal":
      return { label: "Proposal image", needsReview: false };
    case "sales_catalogue":
    case "catalogue":
      return { label: "Approved catalogue image", needsReview: false };
    case "staff_upload":
      return { label: "Uploaded by staff", needsReview: false };
    case "web_search":
    case "image_search":
      return { label: "Selected from image search", needsReview: false };
    case "none":
    case "":
      return { label: "No approved image", needsReview: true };
    default:
      return { label: "Recorded image source", needsReview: false };
  }
}
